var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H25V1.95438H0V0ZM0 5.51882H25V7.4732H0V5.51882ZM25 11.0449H0V12.9993H25V11.0449Z","fill":"white"}));
}

Component.defaultProps = {"width":"25","height":"13","viewBox":"0 0 25 13","fill":"none"};

module.exports = Component;

Component.default = Component;
